<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Edit Podcast</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <router-link to="/admin/podcasts" class="btn btn-primary" role="button">
                        back
                    </router-link>
                </div>
            </div>
            <form @submit.prevent="updatePodcast" v-if="podcast">
                <div class="row justify-content-md-center">
                  <div class="col-12">
                    <div class="row">

                      <div class="col-md-12">
                        <fg-input type="text"
                                      v-model="podcast.title"
                                      label="Enter Podcast Title"
                                      placeholder="Enter Podcast Title"
                                      data-vv-name="title"
                                      cus-name="title"
                        >
                        </fg-input>
                      </div>

                      <div class="col-md-12">
                        <fg-text-area type="text"
                                      v-model="podcast.description"
                                      label="Enter Podcast description"
                                      placeholder="Enter Podcast description"
                                      data-vv-name="description"
                                      cus-name="description"
                        >
                        </fg-text-area>
                      </div>

                      <div class="col-md-12">
                        <fg-input type="text"
                                      v-model="podcast.artist"
                                      label="Enter Podcast artist"
                                      placeholder="Enter Podcast artist"
                                      data-vv-name="artist"
                                      cus-name="artist"
                        >
                        </fg-input>
                      </div>

                      <div class="col-md-12">
                        <fg-input type="text"
                                  v-model="podcast.podcastUrl"
                                  label="Podcast URL"
                                  placeholder="Enter Podcast Url"
                                  data-vv-name="podcastUrl"
                                  cus-name="podcastUrl"
                                  v-validate="rules.quote"
                                  :has-errors="errors"
                                  :is-fields="fields"
                                  >
                        </fg-input>
                      </div>

                      <div class="col-md-12">
                        <fg-input type="text"
                                  v-model="podcast.readMoreUrl"
                                  label="Enter Read More Url"
                                  placeholder="Enter Read More Url"
                                  data-vv-name="readMoreUrl"
                                  cus-name="readMoreUrl"
                        >
                        </fg-input>
                      </div>

                      <div class="col-3" v-if="status.length">
                        <fg-select
                          v-model="podcast.active"
                          label="Status"
                          v-validate="rules.active"
                          data-vv-name="active"
                          cus-name="active"
                          :has-errors="errors"
                          :is-fields="fields"
                          :list="status"
                          selectedKey="id"
                        >
                        </fg-select>
                      </div>
                    </div>
                  </div>
                    <div class="col-6 text-center">
                        <button type="submit" :disabled="errors.any()" class="btn btn-primary btn-fill btn-block">
                            Update Podcast
                        </button>
                    </div>
                </div>
                <div class="clearfix"></div>
            </form>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import { imageHelpers } from '../../../../helpers/lambda'
    import moment from 'moment'
    export default {
        name: 'EditPodcast',
        created (){
          this.$store.dispatch('GETSELECTEDPODCAST', this.$route.params.id).then(() =>{
          this.podcast = this.selectedPodcast;
        })
    },
    data () {
        return {
          podcast: this.selectedPodcast || {},
          rules: {
            title: {required : true},
            description: {required : true},
            artist: {required : true},
            podcastUrl: {required : true},
            active: {required: true}
          },
          message: {
            error: false,
            text: ''
          },
          status: [{name:'Select Status'}, {id:"1", name:'Active'}, {id:"0", name:'Inactive'}],
        }
    },
    methods: {
      updatePodcast () {
        this.$validator.validateAll().then((result) => {
            if (result) {
              let updatePodcast = () =>{
                this.$store.dispatch('UPDATE_PODCAST', this.podcast)
                  .then((res) => {
                    console.log("UPDATE_PODCAST res : ", res);
                    this.showPopup('Success!', 'Podcast is successfully updated', 'success', ()=>this.$router.push('/admin/podcasts'))

                  })
                  .catch(err => {
                    this.showPopup('Error!', 'some thing happen wrong', 'error')
                    console.log("UPDATE_PODCAST API error : ", err);
                  })
              };
              updatePodcast();
            }
          })
        },
        showPopup(title, msg, popupType, cb){
            this.$swal( title, msg, popupType
            ).then(res => {
                        cb && cb();
                        return res
                    })
        }
    },
    computed: {...mapGetters([
        'podcasts', 'selectedPodcast']) }
    }
</script>

<style>
    .form-control{
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Podcast/EditPodcast.vue